import NL from './nl'

export default {
  NL,
}
